export default {
  referenceMarket: {
    id: 'pricing_reference_market',
    defaultMessage: '{country} market is used to set the reference price',
  },
  referenceMarketLink: {
    id: 'reference_market_link',
    defaultMessage: 'Change reference market',
  },
  referenceMarketModalTitle: {
    id: 'reference_market_modal_title',
    defaultMessage: 'Change reference market',
  },
  referenceMarketModalSubtitle: {
    id: 'reference_market_modal_subtitle',
    defaultMessage:
      'Careful, changing your reference market will delete your existing pricing rules.',
  },
  close: {
    id: 'default_market_modal_close',
    defaultMessage: 'Close',
  },
  buttonSubmit: {
    id: 'default_market_modal_button_submit',
    defaultMessage: 'Apply',
  },
}
